import React from 'react';
import UI from 'components/UI';
import {Motion, spring}  from 'react-motion';

class PickerOption extends UI {

  constructor(props){
    super(props);
    this.init(props);
    if(this.props.data){
      this.state = {
        filename: props.data.icon,
        type: props.type,
      }
    }else if(this.props.icon && this.props.type){
      this.state = {
        filename: props.icon,
        type: props.type,
      }
    }else{
      this.state = {
        status: '',
      }
    }
    this.checkUrl();
  }

  UNSAFE_componentWillReceiveProps(newProps){
    this.init(newProps);
    //console.log(this.props.data)
    var newFilename = null;
    if(this.props.data){ newFilename = newProps.data.icon; }
    else if(this.props.icon && this.props.type){ newFilename = newProps.icon; }
    if(!newFilename){ return null; }

    if(this.state.filename !== newFilename){
      this.setState({ filename: newFilename, type: newProps.type?newProps.type:'' }, ()=>{ this.checkUrl(); })
    }

  }

  async onCellSelect(){
    if(this.props.type === 'cardComment'){
      const targetCard = this.store.cards.selectedGradeCard;
      const card = this.props.data;
      targetCard['comment'] = card['comment'];
      this.actions.cards.gradeCard(targetCard.studentProject, 0, targetCard);
      document.getElementById('comment').value = card['comment'];
    }
    else{
      const url = this.props.url? this.props.url: this.url.url;
      const blob = await this.url.urlToBlob(url);
      this.actions.main.setPhoto({url: url, blob: blob});

      if(this.props.data){
        document.getElementById('title').value = this.props.data.title;
        document.getElementById('desc').value = this.props.data.description;

        if(this.props.data.allowedComments){
          const allowedComments = this.props.data.allowedComments.map((allowedComment, i)=>{return {key: i, title: allowedComment}});
          this.actions.allowedComment.setEditAllowedComments(allowedComments);
        }
        if(this.props.data.tags){ 
          if(this.props.type === 'subjectIcon'){ this.actions.subjects.setTags(this.props.data.tags, 'copy'); }
          else{ this.actions.projects.setTags(this.props.data.tags, 'copy'); }
        }
        else if(!this.props.data.tags){ 
          if(this.props.type === 'subjectIcon'){ this.actions.subjects.setTags([], 'copy'); } 
          else{ this.actions.projects.setTags([], 'copy'); } 
        }
        if(this.props.data.audioDesc){
          const audioUrl = await this.func.url(this.props.data.audioDesc, 'projectAudioDesc');
          const audioBlob = await this.url.urlToBlob(audioUrl);
          this.actions.projects.setProjectLangAudio({blob: audioBlob});      
        }
        else if(!this.props.data.audioDesc){
          this.actions.projects.setProjectLangAudio({blob: null});
        }
        if(this.props.type === 'subjectIcon'){
          this.actions.subjects.copy(this.props.data);
        }
        if(this.props.type === 'projectIcon'){
          this.actions.projects.copy(this.props.data);
        }
      }
    }

    if(this.props.onClick){
      this.props.onClick();
    }

    this.actions.main.setDefaultImagePicker('off');
    this.actions.main.setPrefabPicker('off');
  }

  render(){
    this.init(this.props);

    const cellStyle = {
      cursor: 'pointer',
      margin: this.bs.width * 0.01,
      flexShrink: 0,
    }
    const type = this.props.type;
    const isComment = type === 'cardComment';
    const size = [this.bs.width * 0.125, this.bs.width * 0.125];

    const isOpen = this.state.status === 'pointed';

    return(
      <Motion defaultStyle={{scale: isOpen? 1: 1.25}}
      style={{scale: isOpen? spring(1.25): spring(1)}}>
        {style=>(
          <div style={{...cellStyle,...{width: isComment? '': size[0] * style.scale, height: isComment? '':size[1] * style.scale}}}
          onClick={()=>{ this.onCellSelect(); }}
          onPointerEnter={()=>{ this.setState({status: 'pointed' }); this.props.onPointed(); }}
          onPointerLeave={()=>{ this.setState({status: 'not-pointed' }); this.props.onUnPointed();}}>
            {!isComment && <img src={this.props.url? this.props.url: this.url.url} style={{width: '100%', height: '100%'}} alt=''/>}
            {isComment && this.textDisplay(this.props.data.comment, ['100%',''], this.bs.height * 0.075 * style.scale, 'center', 'white')}
          </div>
        )}
      </Motion>
    )
  }

}

export default PickerOption;
